import React, {useState, useEffect} from "react";
import {Top, Bottom, Button, Slide, Slider} from "parts";
import {useNavigate} from "react-router-dom";
import {
  getItem,
  setProfile,
  setStep,
  setTrack,
  setTrackStep,
  useBook,
  usePayment,
  useSurvey
} from "utils";
import {Trans, useTranslation} from "react-i18next";
import {BookEnum, LandingEnum} from "_business";
import {PaywallBook} from "./PaywallBook";
import {BookBundle} from "parts/book";

export function Book({step, nextUrl, preload}) {
  const {
    message,
    custom: {payment_method_id},
    catchError
  } = usePayment({data: getItem('price', null, window.sessionStorage)})

  const
    {t, i18n} = useTranslation('common', {keyPrefix: 'book'}),
    {t: t0} = useTranslation(),
    navigate = useNavigate()

  const
    {
      surveyList,
      state: {resultList}
    } = useSurvey(),
    engNative =
      i18n.resolvedLanguage === 'en' &&
      +resultList?.[
        surveyList.findIndex(({id}) => id === 'native-speaker')
      ]?.[0] === 1,
    // A41 = engNative ? {value: 'A'} : getExperiment('A41'),
    [A41, setA41] = useState({value: 'A'}),
    ultimateOnly = engNative || A41.value === 'A',

    A92 =
      i18n.resolvedLanguage === 'en'
        ? {value: 'B'}
        : {value: 'A'},

    [book, setBook] = useState(
      window.landing === LandingEnum.charisma
        ? BookEnum.charisma
        : (ultimateOnly ? BookEnum.ultimate : BookEnum.bundle)
    ),

    {price, load} = useBook({nextUrl, trackEvent: book})

  useEffect(() => {
    setStep({
      ...step,
      // product: window.localStorage.getItem('product') || 'noname'
    })
  }, [])

  useEffect(() => {
    window.sessionStorage.setItem('book_type', book)
  }, [book])

  const handleClick = (position) => {
    const purchased = getItem('books_purchased', [], window.sessionStorage)

    if (
      // window.sessionStorage.getItem('guide_added') === '1'
      purchased.includes(book)
    ) {
      console.warn('book skip click')
      navigate(nextUrl)
      // mixpanel.track('book skip click', {
      //   product: window.localStorage.getItem('product') || 'noname'
      // });
      return
    }

    // mixpanel.track('book click', {
    //   // product: window.localStorage.getItem('product') || 'noname'
    // })
    setTrackStep('book click', {...step, type: book, position})

    // window.sessionStorage.setItem('guide_added', '1')

    purchased.push(book)
    window.sessionStorage.setItem('books_purchased', JSON.stringify(purchased))

    let fetchCount = 3

    const toFetch = () => {
      fetchCount--

      fetch(
        `${process.env.REACT_APP_API_URI}web-payments/book`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: price.id,
            type: book,
            payment_method: payment_method_id || window.sessionStorage.getItem('payment_method_id'),
            uid: window._uid || window.localStorage.getItem('uid'),
            // transaction_id: window.localStorage.getItem('transaction_id')
          })
        }
      )
        .then(async r => {
          if (r.ok) {
            try {
              let data = {}
              data = await r.json()

              if (data.success) {
                setProfile({book_purchase: true})
                setTrackStep('book successful', {...step, type: book, ...data})
                // window.sessionStorage.setItem('book_success', '1')

                // purchased.push(book)
                // window.sessionStorage.setItem('books_purchased', JSON.stringify(purchased))

                // if (window.purchasedCallback)
                //   window.purchasedCallback(purchased)
              } else {
                // if (fetchCount > 0)
                //   setTimeout(() => toFetch(), 10000)
                // else
                  catchError(data, 'book failed', false, false)
              }
            } catch (ex) {
              if (fetchCount > 0)
                setTimeout(() => toFetch(), 10000)
              else
                catchError(ex, 'book catched', false, false)
            }
          } else {
            if (fetchCount > 0)
              setTimeout(() => toFetch(), 10000)
            else
              catchError(r, 'book blocked', false, false)
          }

          // mixpanel.track('book checkout', {
          //   // product: window.localStorage.getItem('product') || 'noname',
          //   ok: r.ok,
          //   ...data
          // })
        })
    }
    toFetch()

    if (
      window.landing !== LandingEnum.charisma &&
      i18n.resolvedLanguage === 'en' && book === BookEnum.ultimate &&
      !purchased.includes(BookEnum.charisma)
    ) {
      setBook(BookEnum.charisma)
      setTrack(BookEnum.charisma)
      // window.sessionStorage.setItem('guide_added', '0')
    } else if (
      window.landing === LandingEnum.charisma &&
      book === BookEnum.charisma &&
      !purchased.includes(ultimateOnly ? BookEnum.ultimate : BookEnum.bundle)
    ) {
      const b = ultimateOnly ? BookEnum.ultimate : BookEnum.bundle
      setBook(b)
      setTrack(b)
      // window.sessionStorage.setItem('guide_added', '0')
    } else
      navigate(nextUrl)
  }

  const handleSkip = () => {
    const
      purchased = getItem('books_purchased', [], window.sessionStorage)
      // viewed = getItem('books_viewed', [], window.sessionStorage)

    // viewed.push(book)
    // window.sessionStorage.setItem('books_viewed', JSON.stringify(viewed))

    if (
      window.landing !== LandingEnum.charisma &&
      i18n.resolvedLanguage === 'en' && book === BookEnum.ultimate &&
      !purchased.includes(BookEnum.charisma)
    ) {
      setBook(BookEnum.charisma)
      setTrack(BookEnum.charisma)
    } else if (
      window.landing === LandingEnum.charisma &&
      book === BookEnum.charisma &&
      !purchased.includes(ultimateOnly ? BookEnum.ultimate : BookEnum.bundle)
    ) {
      const b = ultimateOnly ? BookEnum.ultimate : BookEnum.bundle
      setBook(b)
      setTrack(b)
    } else if (engNative || book === BookEnum.bundle || purchased.includes(BookEnum.ultimate))
      navigate(nextUrl)
    else {
      setBook(BookEnum.bundle)

      if (A92.value === 'A')
        setTrack(BookEnum.bundle)

      setA41({value: 'B'})
    }
  }

  if (!price || load)
    return (
      <div className={'wrap fixed'}>
        <Top type={'center'} style={{justifyContent: 'center'}}>
          <span className={'spinner'}></span>
        </Top>
      </div>
    )

  if (book === BookEnum.charisma)
    return <PaywallBook price={price} onClick={handleClick} onSkip={handleSkip} message={message}/>
  else if (book === BookEnum.bundle && A92.value === 'B')
    return <BookBundle price={price} onClick={handleClick} onSkip={handleSkip} message={message}/>

  // const A28 = i18n.resolvedLanguage === 'en' ? getExperiment('A28') : {value: 'A'};

  const renderBook = (key) => {
    return (
      <div className={'block items h-100 rounded-2'}
           style={{
             alignItems: 'center', padding: '19px 14px', gap: 15,
             background: 'linear-gradient(79.63deg, #2072F3 7.74%, #391A6B 92.26%)'
           }}
      >
        {
          !ultimateOnly &&
          <h2 className={'h3'}>{t(`${key}.h2`)}</h2>
        }
        <div className={'row center'}>
          <div className={'w-100'}>
            <img alt="" width={160} height={160} className={'mw-100 mx-auto'}
                 src={`/static/i18/${['book1', 'ultimate'].includes(key) ? i18n.resolvedLanguage : 'en'}/img/book/${key}.png`}
            />
          </div>
          <div>
            <ul className={'small text-start pre-line mb-2'} style={{width: 146}}>
              <Trans i18nKey={`${key}.list`} t={t}>
                <li>20+ guided voice trainings</li>
                <li>Expert-level tips and advices</li>
                <li>Train for just 3 minutes per day</li>
              </Trans>
            </ul>

            <div className={'row sm'}>
              <Trans i18nKey={`${key}.tags`} t={t}>
                <span className={'tag tag-btn-sm'}>e-book</span>
                <span className={'tag tag-btn-sm'}>pdf</span>
              </Trans>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const
    ns = ultimateOnly ? 'one.' : '',
    icons = ['training', 'education', 'clock', 'amount']

  return (
    <div className={'wrap fixed'}>
      <Top type={'center'} reload={true}>
        {message && <div id="payment-message">{message}</div>}

        {
          A92.value === 'B'
            ?
            <>
              <h1>This guide is a <span className={'marked'}>great addition</span> for your plan</h1>

              <div className={'block text-center stack'}
                   style={{
                     padding: '20px 12px 12px 12px',
                     background: 'radial-gradient(50% 50% at 50% 50%, rgba(57, 110, 255, 0.32) 0%, rgba(57, 110, 255, 0) 100%), linear-gradient(0deg, #121620, #121620)'
                   }}
              >
                <h2 style={{marginBottom: 4}}>{t('ultimate.h2')}</h2>

                <img src={'/static/img/book/book.png'} alt="book" width={222} height={160} className={'mw-100 mx-auto'}/>

                <div className={'w-100 cards gap-2'}>
                  {t('ultimate.list2').split(';').map((item, i) =>
                    <div key={item} className={'panel row pre-line rounded-2 small-sm'}
                         style={{backgroundColor: 'rgba(149, 177, 255, 0.12)'}}>
                      <img src={`/static/img/book/${icons[i]}.svg`} width={16} height={16} alt={'Training'}/>
                      <span className={'text-start'} dangerouslySetInnerHTML={{__html: item}}/>
                    </div>
                  )}
                </div>
              </div>
            </>
            :
            <>
              <h1 className={'h2 pre-line'}>{t(`${ns}h1`)}</h1>

              {
                ultimateOnly
                  ?
                  <>
                    <p className={'notice small'}>{t('one.notice')}</p>
                    <div className={'w-100'}>
                      {renderBook(Object.keys(BookEnum).find(key => BookEnum[key] === book))}
                    </div>
                  </>
                  :
                  <Slider view={true}>
                    {
                      // onSlide={(index) => setBook(Object.entries(BookEnum)[index][1])}
                      // Object.entries(BookEnum).map(([key, value], i) =>
                      ['bundle', 'ultimate', 'accent'].map((key, i) =>
                        <Slide key={key} index={i}>
                          {
                            key === 'bundle'
                              ?
                              <div className={'block h-100 rounded-2'}
                                   style={{
                                     padding: 16,
                                     background: `#17153d url("/static/img/book/bundle-back.png") center`,
                                     backgroundSize: 'cover'
                                   }}
                              >
                                <div className={'w-100'}>
                                  <img alt="" width={268} height={217} className={'mw-100 mx-auto'}
                                       style={{marginTop: -20, marginBottom: -40}}
                                       src={`/static/i18/en/img/book/${key}.png`}
                                  />
                                </div>
                                <h2 className={'h3 pre-line'}>{t(`${key}.h2`)}</h2>
                              </div>
                              : renderBook(key)
                          }
                        </Slide>
                      )
                    }
                  </Slider>
              }

              <p className={'notice small mb-2'}>{t(`${ns}note`)}</p>
            </>
        }

        <div className={'items w-100'}>
          <div className={'block-plan active'} style={{position: 'relative'}}>
            {
              price[book].promo &&
              <div className={'promo small'}><em>
                {price[book].promo[i18n.resolvedLanguage] || price[book].promo['en'] || price[book].promo}
              </em></div>
            }
            <div className={'item'}>
              <div className={'w-100 text-start'}>
                <strong>
                  {
                    A92.value === 'B'
                      ? 'Limited-Time Offer'
                      : price[book].name[i18n.resolvedLanguage] || price[book].name['en'] || price[book].name
                  }
                </strong>
                <p>
                  <span className={'note lg'}>
                    {t('original', {
                      currency: price.currency,
                      currencySymbol: price.currencySymbol,
                      fullPrice: price[book].old_price || price[book].full_price,
                    })}
                  </span>
                </p>
              </div>
              <div className={'nowrap'}>
                <sup>{price.currencySymbol}</sup>
                <big style={{fontSize: 40, fontWeight: 'bold'}}>{Math.trunc(price[book].price)}</big>
                <div>
                  <em>{Math.round(price[book].price % 1 * 100)}</em>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Button onClick={() => handleClick('top')}>{t(`${ns}btn`)}</Button>
        <Button variant={''} onClick={handleSkip}>{A92.value === 'B' ? t0('next') : t0('skip')}</Button>
      </Top>

      <Bottom preload={preload}/>
    </div>
  )
}